import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.555 19.832V6.492M20.55 15.819l-3.996 4.013-3.994-4.013M6.828 3.833v13.34M2.834 7.846l3.994-4.014 3.995 4.014",
      style: {"stroke":"inherit"}
    }, null, -1)
  ])))
}
export default { render: render }